import { render, staticRenderFns } from "./telephone.vue?vue&type=template&id=3d296328&"
import script from "./telephone.vue?vue&type=script&lang=js&"
export * from "./telephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports